<template>
  <div class="background-03">

    <v-layout row wrap>
      <v-flex xs12 sm9 class="animated fadeInLeft dura_1">
        <ui-title-one titleAccess="¿Qué pasa si sus ingresos son menores a sus gastos?" titleLevel="h1">
          <template slot="partOne"> ¿Qué pasa si sus ingresos <br></template>
          <template slot="partTwo">son menores a</template>
          <template slot="partThree"> sus gastos? </template>
        </ui-title-one>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'Flujo de caja en rojo'" videoEmbed="ADMINISTRACIONDINERO42FlujoCajaEnRojo.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 sm2 md1 class="hidden-xs-only aligner">
        <image-app class="animated fadeInDown" :imaSize="40" imaSrc="design/banco3-1-1_3" imaAlt=""></image-app>
      </v-flex>
      <v-flex xs12 sm5 md5 class="animated fadeInUp dura_2 aligner">
        <p class="text-box adorn-bottom">
          Si sus ingresos son menores a sus gastos, <strong>su flujo de caja está en rojo</strong>, sus
          <strong>deudas</strong> podrían aumentar y está en problemas o gastando sus ahorros.
          En últimas, <strong>su patrimonio puede disminuir</strong>.
        </p>
      </v-flex>
      <v-flex xs12 sm5 md5 mb-5 text-xs-center class="aligner animated fadeIn dura_2">
        <image-app class="animated fadeInLeft" :imaSize="397" imaSrc="contenido/diapositiva_43" imaAlt="Flujo de caja en rojo, disminución de ahorros"></image-app>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-42.vue?1b381797